import { ListaPerguntaResponse } from 'api/Assessor/duvidas';
import { AssembleiaPautaStatus } from 'enuns/AssembleiaPautaStatus';
import { TipoCargosChapa } from 'enuns/TipoCargosChapa';
import { TipoPauta } from 'enuns/TipoPauta';
import { AssembleiaContaAssociado } from 'models/AssembleiaContaAssociado';
import AssembleiaProduto from 'models/AssembleiaProduto';
import AssembleiaProdutosPorTipo from 'models/AssembleiaProdutosPorTipo';
import AssembleiaProdutoTipo from 'models/AssembleiaProdutoTipo';
import AssembleiaTipo from 'models/AssembleiaTipo';
import { ListaEventoResponse } from 'models/ListaEventoResponse';
import TipoDocumento from 'models/TipoDocumento';
import { AssembleiasAssessorActionTypes, ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA, ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT, ASSEMBLEIAS_ASSESSOR_ACTIONS_CLEARED_CURRENT_EVENT, ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS, ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE, ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA, ASSEMBLEIAS_ASSESSOR_ALTERA_URL_TRANSMISSAO, ASSEMBLEIAS_ASSESSOR_ATUALIZANDO_CONVOCADOS, ASSEMBLEIAS_ASSESSOR_ATUALIZAR_CONVOCADOS, ASSEMBLEIAS_ASSESSOR_BLOQUEANDO_CONVOCACOES, ASSEMBLEIAS_ASSESSOR_BLOQUEAR_CONVOCACOES, ASSEMBLEIAS_ASSESSOR_BUSCAR_PAUTA, ASSEMBLEIAS_ASSESSOR_CADASTRAR, ASSEMBLEIAS_ASSESSOR_DELETAR, ASSEMBLEIAS_ASSESSOR_EDITAR, ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA, ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS, ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS, ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO, ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO, ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_PAGINADA_EVENTO, ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS, ASSEMBLEIAS_ASSESSOR_LOADING_PRESENCAS, ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS, ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS_POR_TIPO, ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS, ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_DOCUMENTOS, ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_PRODUTO, ASSEMBLEIAS_ASSESSOR_LOAD_AGENCIAS_PAUTA, ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS, ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS, ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO, ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO, ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_PAGINADA_EVENTO, ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS, ASSEMBLEIAS_ASSESSOR_LOAD_PRESENCAS, ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS, ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS_POR_TIPO, ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS, ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_DOCUMENTOS, ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_PRODUTO, ASSEMBLEIAS_ASSESSOR_REFRESH, ASSEMBLEIAS_ASSESSOR_ACTIONS_REGISTRA_VOTO, ASSEMBLEIAS_ASSESSOR_FORCE_LOAD_PAUTAS } from './AssembleiasAssessorActionTypes';
import { AUTH_ACTIONS_LOGOUT, IAuthActionsLogout } from './AuthActionTypes';
import { WSAssembleiasActionTypes } from './WSAssembleiasActionTypes';
import { IWSAssembleia } from './WSAssembleiasReducer';
import { DocumentoResponse } from 'api/Assessor/documentos';
import { AssembleiaContaAssessor } from 'models/AssembleiaContaAssessor';

type DateJSON = string;
type AssembleiaStatusDesc =
  | 'NAO_DISPONIVEL'
  | 'PRE_ASSEMBLEIA'
  | 'ASSEMBLEIA'
  | 'POS_ASSEMBLEIA'
  | 'ENCERRADO';
export interface IAssembleiasAssessorEvent {
  colaboradoresPresentes: number,
  dataBloqueio: DateJSON,
  dataCadastro: DateJSON,
  dataEvento: DateJSON,
  dataEventoFim: DateJSON,
  descricao: string,
  documentos: IAssembleiasAssessorDocumentos[],
  id: number,
  nome: string,
  presentes: number,
  usuariosLogados: number,
  status: number,
  statusDesc: string;
  statusChat: boolean,
  tipo: string,
  tipoAssembleia: AssembleiaTipo,
  urlTransmissao: string,
  videos: IAssembleiasAssessorYTVideos[],
  pautas?: IAssembleiasAssessorPauta[],
  needLoadPautas: boolean,
  needLoadAssembleia: boolean,
  produtos: AssembleiaProduto[],
  flgBloqueio: boolean;
  flgConvocado: boolean;
}

export interface IAssembleiasAssessorDocumentos {
  desDocumento: string,
  nomDocumento: string,
  oidDocumento: number,
  tipoDocumento: string,
  flgDisponivelAssociado: boolean;
}

export interface IAssembleiasAssessorYTVideos {
  descricao: string,
  oidVideo: number,
  urlYoutube: string
}

export interface IAssembleiasAssessorEventList {
  descricao: string,
  id: number,
  nome: string,
  status: number,
  tipo: string
}

export interface IAssembleiasAssessorPauta {
  codigoAgencia: string,
  datEdicao: string,
  descricao: string,
  idPauta: number,
  itens: IAssembleiasAssessorItens[],
  flgResultadoLiberado: boolean,
  produtos: AssembleiaProduto[],
  numeroNucleo: string,
  ordem: number,
  status: AssembleiaPautaStatus,
  tempoVotacao: number,
  tempoRestante: number,
  tipoPauta: TipoPauta,
  titulo: string,
  idsProdutos: number[],
  votos: any[]
}

export interface IAssembleiasAssessorItens {
  descricao: string,
  flgAbstencao: boolean,
  idItemPauta: number,
  representantesChapa: IRepresentantesChapa[];
  ordem: number;
}

export interface IRepresentantesChapa {
  associado: string,
  idCargo: 0,
  idRepresentanteChapa: 0,
  nomeCargo: TipoCargosChapa
}

export interface IAssembleiasAssessoresAlteraStatusPauta {
  idPauta: number,
  minutos: number,
  status: number
}

export interface IAssembleiasAssessoresRegistrarPresenca {
  convocacoes: number[],
  cpf: string | undefined,
  idEvento: number | undefined
}

export interface IAssembleiaContasAssessor {
  assembleiaId: number,
  contas: AssembleiaContaAssociado[],
}

export interface IAssembleiaAssessorLoadDuvidas {
  dataDuvida: DateJSON,
  duvida: string,
  idDuvidaFrequente: number,
  usuarioDuvida: string
}

export interface IListaAgenciasPauta {
  codigoAgencia: string,
  nucleos: string[]
}

export interface IRequestPautasRespostas {
  codigoAgencia: string,
  idPauta: number,
  itensPauta: IPautaRespostaItemRequest[],
  numeroNucleo: string
}

export interface IPautaRespostaItemRequest {
  idItemPauta: number,
  quantidadeVotos: number
}

export interface ICadastrarPautaRequest {
  descricao: string,
  idAssembleia: number,
  idsProdutos: number[],
  idPauta?: number,
  itens: IItensCadastrarPautaRequest[],
  titulo: string
}

export interface IItensCadastrarPautaRequest {
  descricao: string,
  flgAbstencao: boolean,
  idItemPauta?: number,
  ordem: number
}

export interface IAssembleiaResultado {
  cotas: number,
  descricao: string,
  idItemPauta: number,
  porcentagem: number
}
export interface IAssembleiaResultadosVotos {
  tituloPauta: string,
  mensagemResultado?: string,
  tituloAssembleia: string,
  tituloTipoAssembleia: string,
  tipoPauta: string,
  idPauta: number,
  descricao: string,
  flgValido?: boolean,
  resultado?: IAssembleiaResultado[],
  pautasIsValid: boolean
}

export interface IAssembleiasAssessorReducer {
  loadingPresencas: boolean,
  loadingEvento: boolean,
  evento: IAssembleiasAssessorEvent | null,
  loadingListaEvento: boolean,
  listaEvento: IAssembleiasAssessorEventList[],
  loadingListaPaginadaEvento: boolean,
  listaPaginadaEvento: ListaEventoResponse | null,
  needLoadListaEvento: boolean,
  loadingPautas: boolean,
  pautas: IAssembleiasAssessorPauta[],
  alterandoStatusPauta: boolean,
  loadingContas: boolean,
  // contasDisponiveis?:  AssembleiaContaAssociado[],
  contasDisponiveis?:  AssembleiaContaAssessor[],
  loadingDuvidas: boolean,
  duvidas: ListaPerguntaResponse,
  loadingAgenciasPauta: boolean,
  agenciasPauta: IListaAgenciasPauta[],
  downloadindDocument: number[],
  downloadSuccessfully: number[],
  loadingTiposProduto: boolean,
  tiposProduto: AssembleiaProdutoTipo[],
  loadingProdutosPorTipo: boolean,
  produtosPorTipo: AssembleiaProdutosPorTipo[],
  loadingProdutos: boolean,
  produtos: AssembleiaProduto[],
  loadingTipos: boolean,
  tipos: AssembleiaTipo[],
  loadingTiposDocumento: boolean,
  tiposDocumento: TipoDocumento[],
  atualizandoConvocados: boolean;
  bloqueandoConvocacoes: boolean;
  documentos: DocumentoResponse[];
}

const INITIAL_STATE: IAssembleiasAssessorReducer = {
  loadingPresencas: false,
  loadingEvento: false,
  evento: null,
  loadingListaEvento: false,
  listaEvento: [],
  loadingListaPaginadaEvento: false,
  listaPaginadaEvento: null,
  needLoadListaEvento: true,
  loadingPautas: false,
  pautas: [],
  alterandoStatusPauta: false,
  loadingContas: false,
  loadingDuvidas: false,
  duvidas: [],
  loadingAgenciasPauta: false,
  agenciasPauta: [],
  downloadindDocument: [],
  downloadSuccessfully: [],
  loadingTiposProduto: false,
  tiposProduto: [],
  loadingProdutosPorTipo: false,
  produtosPorTipo: [],
  loadingProdutos: false,
  produtos: [],
  loadingTipos: false,
  tipos: [],
  loadingTiposDocumento: false,
  tiposDocumento: [],
  atualizandoConvocados: false,
  bloqueandoConvocacoes: false,
  documentos: [],
}

const getRefreshedState = (state: IAssembleiasAssessorReducer, assembleia: IWSAssembleia):IAssembleiasAssessorReducer => {
  const newState: IAssembleiasAssessorReducer = { ...state };
  newState.needLoadListaEvento = typeof assembleia.needLoadList === 'boolean' ? assembleia.needLoadList : newState.needLoadListaEvento;
  if (newState.evento && (newState.evento.id === assembleia.id || newState.evento.id === assembleia.idPauta)) {
    newState.evento = {
      ...newState.evento,
      presentes: typeof assembleia.presentes === 'number' ? assembleia.presentes : newState.evento.presentes,
      usuariosLogados: typeof assembleia.usuariosLogados === 'number' ? assembleia.usuariosLogados : newState.evento.usuariosLogados,
      status: typeof assembleia.status === 'number' ? assembleia.status : newState.evento.status,
      needLoadAssembleia: typeof assembleia.needLoadAssembleia === 'boolean' ? assembleia.needLoadAssembleia : false,
      needLoadPautas: typeof assembleia.needLoadPautas === 'boolean' ? assembleia.needLoadPautas : false,
      statusChat: typeof assembleia.isChatAtivo === 'boolean' ? assembleia.isChatAtivo : newState.evento.statusChat,
      pautas: newState.evento.pautas
        ? newState.evento.pautas.map((pauta) => {
          const filteredRefreshedPautas = assembleia.pautas ? assembleia.pautas.filter((pautaRefreshed) => pautaRefreshed.idPauta === pauta.idPauta) : [];
          if (filteredRefreshedPautas.length > 0) {
            return {
              ...pauta,
              flgResultadoLiberado: typeof filteredRefreshedPautas[0].flgResultadoLiberado === 'boolean' ? filteredRefreshedPautas[0].flgResultadoLiberado : pauta.flgResultadoLiberado,
              status: typeof filteredRefreshedPautas[0].status === 'number' ? filteredRefreshedPautas[0].status : pauta.status,
              tempoRestante: filteredRefreshedPautas[0].tempoRestante || filteredRefreshedPautas[0].tempoVotacao,
              tempoVotacao: filteredRefreshedPautas[0].tempoVotacao,
            }
          }
          return pauta;
        })
        : []
    };
  }
  if (newState.listaEvento && newState.listaEvento.length > 0) {
    newState.listaEvento = newState.listaEvento.map((evento) => {
      if (evento.id === assembleia.id || evento.id === assembleia.idPauta) {
        return {
          ...evento,
          status: typeof assembleia.status === 'number' ? assembleia.status : evento.status
        }
      }
      return evento;
    })
  }
  return newState;
}

export default (state: IAssembleiasAssessorReducer = INITIAL_STATE, action: AssembleiasAssessorActionTypes | WSAssembleiasActionTypes | IAuthActionsLogout) => {
  switch (action.type) {
    // case WS_ASSEMBLEIAS_ACTIONS_OPEN:
    //   return {
    //     ...state,
    //     needLoadListaEvento: true,
    //     evento: (
    //       state.evento ?
    //         {
    //           ...state.evento,
    //           needLoadAssembleia: true
    //         } :
    //       state.evento
    //     )
    //   }
    case ASSEMBLEIAS_ASSESSOR_REFRESH:
      return getRefreshedState(state, action.payload);
    case ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO:
      return { ...state, loadingEvento: action.payload, evento: { ...state.evento, needLoadAssembleia: false } }
    case ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO:
      return { ...state, evento: { ...state.evento, ...action.payload, refreshedTimes: 0, needLoadPautas: true } }
    case ASSEMBLEIAS_ASSESSOR_LOADING_PRESENCAS:
      return { ...state, loadingPresencas: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOAD_PRESENCAS:
      if (state.evento && state.evento.id === action.payload.idEvento) {
        return { ...state, evento: { ...state.evento, usuariosLogados: action.payload.usuariosLogados}}
      }
      return { ...state };
    case ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE:
      return { ...state, downloadindDocument: action.payload };
    case ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS:
      return { ...state, downloadSuccessfully: action.payload };
    case ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT:
    case ASSEMBLEIAS_ASSESSOR_ACTIONS_CLEARED_CURRENT_EVENT:
      return { ...state, evento: null }
    case ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO:
      return { ...state, loadingListaEvento: action.payload, needLoadListaEvento: false }
    case ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO:
      return { ...state, listaEvento: action.payload }
    case ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_PAGINADA_EVENTO:
      return { ...state, loadingListaPaginadaEvento: action.payload }
    case ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_PAGINADA_EVENTO:
      return { ...state, listaPaginadaEvento: action.payload }
    case ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS:
      return { ...state, loadingPautas: action.payload, evento: { ...state.evento, needLoadPautas: false } }
    case ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS:
      return { ...state, evento: { ...state.evento, pautas: action.payload } }
      case ASSEMBLEIAS_ASSESSOR_BUSCAR_PAUTA:
      return { ...state, evento: { ...state.evento, id: action.idAssembleia, pautas: action.payload } }
    case ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA:
      return { ...state, alterandoStatusPauta: action.payload }
    case ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS:
      return { ...state, loadingContas: action.payload  }
    case ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS:
      return { ...state, contasDisponiveis: action.payload, evento: { ...state.evento }  }
    case ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS:
      return { ...state, loadingDuvidas: action.payload }
    case ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS:
      return { ...state, duvidas: action.payload }
    case ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA:
      return { ...state, loadingAgenciasPauta: action.payload }
    case ASSEMBLEIAS_ASSESSOR_LOAD_AGENCIAS_PAUTA:
      return { ...state, agenciasPauta: action.payload }
    case ASSEMBLEIAS_ASSESSOR_FORCE_LOAD_PAUTAS:
    case ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA:
    case ASSEMBLEIAS_ASSESSOR_ACTIONS_REGISTRA_VOTO:
      return {
        ...state,
        evento: {
          ...(state.evento || {}),
          needLoadPautas: true
        }
      }
    case ASSEMBLEIAS_ASSESSOR_DELETAR:
      return { ...state, listaEvento: state.listaEvento.filter(
        (evento): boolean => {
          return evento.id !== action.payload
        }
      ) };
    case ASSEMBLEIAS_ASSESSOR_CADASTRAR:
      return { ...state, needLoadListaEvento: true };
    case ASSEMBLEIAS_ASSESSOR_EDITAR:
      return {
        ...state,
        needLoadListaEvento: true,
        evento: (
          state.evento ?
            {
              ...state.evento,
              needLoadAssembleia: true
            } :
          state.evento
        )
      }
    case ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS:
      return { ...state, loadingTipos: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS:
      return { ...state, tipos: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_PRODUTO:
      return { ...state, loadingTiposProduto: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_PRODUTO:
      return { ...state, tiposProduto: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS_POR_TIPO:
      return { ...state, loadingProdutosPorTipo: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_DOCUMENTOS:
      return { ...state, loadingTiposDocumento: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_DOCUMENTOS:
        return { ...state, tiposDocumento: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS_POR_TIPO:
      let newProdutosPorTipo = [ ...state.produtosPorTipo ];
      const index = newProdutosPorTipo.map((tipo: AssembleiaProdutosPorTipo): number => tipo.idTipoProduto).indexOf(action.payload.idTipoProduto);
      if (index > -1) {
        newProdutosPorTipo[index] = action.payload;
      } else {
        newProdutosPorTipo.push(action.payload);
      }
      return { ...state, produtosPorTipo: newProdutosPorTipo };
    case ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS:
      return { ...state, loadingProdutos: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS:
      return { ...state, produtos: action.payload };
    case ASSEMBLEIAS_ASSESSOR_ALTERA_URL_TRANSMISSAO:
      let evento = state.evento && state.evento.id === action.payload.idAssembleia ? state.evento : null;
      if (evento) {
        evento.urlTransmissao = action.payload.urlTransmissao;
      }
      return { ...state, evento: evento }
    case ASSEMBLEIAS_ASSESSOR_ATUALIZANDO_CONVOCADOS:
      return { ...state, atualizandoConvocados: action.payload };
    case ASSEMBLEIAS_ASSESSOR_ATUALIZAR_CONVOCADOS:
      if (state.evento?.id === action.payload.idAssembleia) {
        return { ...state, evento: { ...state.evento, flgConvocado: action.payload.flgConvocado } };
      }
      return state;
    case ASSEMBLEIAS_ASSESSOR_BLOQUEANDO_CONVOCACOES:
      return { ...state, bloqueandoConvocacoes: action.payload };
    case ASSEMBLEIAS_ASSESSOR_BLOQUEAR_CONVOCACOES:
      if (state.evento?.id === action.payload.idAssembleia) {
        return { ...state, evento: { ...state.evento, flgBloqueio: action.payload.flgBloqueio } };
      }
      return state;
    case AUTH_ACTIONS_LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
